import { configureSyncfusionLicense } from '@yardi/yardi-react-framework';

export const registerSyncfusionLicense = () => {
  const licenseKey = import.meta.env.VITE_SYNCFUSION_LICENSE_KEY;
  if (licenseKey) {
    // License key found, registering silently
    configureSyncfusionLicense(licenseKey);
  } else {
    console.warn('⚠️ VITE_SYNCFUSION_LICENSE_KEY not found');
  }
};
